import {
	type QueryKey,
	type UseInfiniteQueryOptions,
	type UseInfiniteQueryResult,
	useInfiniteQuery as useInfiniteQueryOriginal,
} from "react-query";

import { useRegisterQueries } from "./use-register-queries";

export function useInfiniteQuery<
	TQueryFnData = unknown,
	TError = unknown,
	TData = TQueryFnData,
	TQueryKey extends QueryKey = QueryKey,
>(
	options: UseInfiniteQueryOptions<TQueryFnData, TError, TData, TQueryFnData, TQueryKey>,
): UseInfiniteQueryResult<TData, TError> {
	useRegisterQueries(options.queryKey ? [options.queryKey] : []);

	return useInfiniteQueryOriginal(options);
}
